module.exports = __webpack_public_path__ + "assets/img/821587017478_.pic_hd.d7a5a0a1.jpg";